import { combineReducers } from 'redux'
import migrationEntityReducer from './migration-entity/migration.entity.reducer'
import migrationsListReducer from './migrations-list/migrations.list.reducer'
import userReducer from './user/user.reducer'

export default combineReducers({
    migrationEntityReducer,
    migrationsListReducer,
    userReducer
})


// WEBPACK FOOTER //
// ./src/js/reducers/index.js